"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Keyboard controls feature for InfiniTable.
 *
 * Enabled by default.
 */
ngModule.factory("itKeyboardControls", function (keyCodes) {
  return function (tableCtrl) {
    var controls = this,
      ctrl = tableCtrl,
      $el = tableCtrl.getElement(),
      $scope = tableCtrl.getScope();

    // keydown listener on the main table element.
    $el.keydown(function (event) {
      // get the handler map
      var keyHandlerMap = getKeyHandlerMap(); // TODO : only once per table configuration load.
      // get the handler. declared -> we execute it.
      var keyHandler = keyHandlerMap[event.which];
      if (keyHandler != null) {
        keyHandler(event, ctrl, $scope);
      }
    });
    function getKeyHandlerMap() {
      var handlerMap = {};

      // default key handlers
      handlerMap[keyCodes.UP] = upKeyDefaultHandler;
      handlerMap[keyCodes.DOWN] = downKeyDefaultHandler;
      handlerMap[keyCodes.PAGE_UP] = pageUpKeyDefaultHandler;
      handlerMap[keyCodes.PAGE_DOWN] = pageDownKeyDefaultHandler;

      // row selection key handlers
      var hasSelectionEnabled = tableCtrl.getConfig().allowSelection;
      if (hasSelectionEnabled) {
        handlerMap[keyCodes.UP] = upKeyRowSelectionHandler;
        handlerMap[keyCodes.DOWN] = downKeyRowSelectionHandler;
      }

      // tree key handlers
      var isTree = tableCtrl.getConfig().type === "tree";
      if (isTree) {
        handlerMap[keyCodes.LEFT] = leftKeyTreeHandler;
        handlerMap[keyCodes.RIGHT] = rightKeyTreeHandler;
      }
      return handlerMap;
    }
  };

  // default handlers

  function upKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.offset(-1);
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }
  function downKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.offset(1);
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }
  function pageUpKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.pageUp();
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }
  function pageDownKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.pageDown();
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }

  //// row selection handlers;

  function upKeyRowSelectionHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    var selectionChanged = selectionFeature.selectPreviousRow();
    if (selectionChanged) {
      keepSelectionInTableScroll(ctrl);
      event.preventDefault();
      $scope.$apply();
    }
  }
  function downKeyRowSelectionHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    var selectionChanged = selectionFeature.selectNextRow();
    if (selectionChanged) {
      keepSelectionInTableScroll(ctrl);
      event.preventDefault();
      $scope.$apply();
    }
  }
  function keepSelectionInTableScroll(ctrl) {
    var selectionIndex = ctrl.getSelectionFeature().getRowSelectionIndex(),
      pagination = ctrl.context.pagination,
      firstIdx = pagination.first,
      lastIdx = pagination.last;

    // console.log("key down ->", selectionIndex, firstIdx, lastIdx);

    if (selectionIndex < firstIdx) {
      ctrl.scroll.offset(-1);
    } else if (selectionIndex > lastIdx) {
      ctrl.scroll.offset(selectionIndex - lastIdx);
    }
  }

  //// tree handlers

  function leftKeyTreeHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    if (!selectionFeature) return;
    var selectionIndex = selectionFeature.getRowSelectionIndex();
    if (selectionIndex === -1) return;
    var renderer = ctrl.getRenderer();
    var flattenedTree = renderer.getActualSource();
    var node = flattenedTree[selectionIndex];
    if (node && node.expanded && renderer.hasChildren(node)) {
      // Collapse the node
      renderer.collapseNode(node.nodeId);
      event.preventDefault();
      $scope.$apply();
    } else if (node && node.parent) {
      // Select parent
      var parentIndex = _.findIndex(flattenedTree, function (n) {
        return n.nodeId === node.parent.nodeId;
      });
      if (parentIndex !== -1) {
        selectionFeature.selectRow(parentIndex);
        keepSelectionInTableScroll(ctrl);
        event.preventDefault();
        $scope.$apply();
      }
    }
  }
  function rightKeyTreeHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    if (!selectionFeature) return;
    var selectionIndex = selectionFeature.getRowSelectionIndex();
    if (selectionIndex === -1) return;
    var renderer = ctrl.getRenderer();
    var flattenedTree = renderer.getActualSource();
    var node = flattenedTree[selectionIndex];
    if (node && !node.expanded && renderer.hasChildren(node)) {
      // Expand the node
      renderer.expandNode(node.nodeId);
      event.preventDefault();
      $scope.$apply();
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itKeyboardControls.js
// module id = 2799
// module chunks = 13